export { default } from './useOnMount';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useOnMount/index.js
// module id = 1609
// module chunks = 22